<template>
  <section>
    <spinner v-if="isLoading"></spinner>
    <div class="content-wrapper">
      <div class="content-heading">
        All users
        <small data-localize="dashboard.WELCOME"></small>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div id="panelChart9" class="panel panel-default">
            <div class="panel-title">Retry Payment</div>
            <div class="line-separator"></div>
            <div class="bottom-margin">
              <div class="row top-margin">
                <div class="col-md-3">
                  <div>
                    <label>Transaction ID:</label>
                  </div>
                </div>
                <div class="col-md-3">
                  <div>
                    <p class="text-center">{{ transactionId }}</p>
                  </div>
                </div>
                <div class="col-md-3">
                  <div>
                    <label>Transaction Amount:</label>
                  </div>
                </div>
                <div class="col-md-2">
                  <div>
                    <p class="text-center">$ {{ transactionAmount }}</p>
                  </div>
                </div>
              </div>
              <div class="line-separator"></div>
              <div class="row top-margin">
                <div class="col-md-3">
                  <div>
                    <label>Bank account *</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div>
                    <select
                      name="fundingSource"
                      v-model="selectedFundingSource"
                      id="FundingSource"
                      class="form-control"
                      placeholder="Please select"
                      v-validate="{ required: true }"
                    >
                      <option
                        v-for="fundingSource in fundingSources"
                        :value="fundingSource.id"
                        :key="fundingSource.id"
                      >
                        {{ fundingSource.name }}
                      </option>
                      <option
                        :value="donateFundingSource.name"
                      >
                        {{ donateFundingSource.text }}
                      </option>
                    </select>
                  </div>
                  <p
                    class="top-margin"
                    style="color: red"
                    v-if="this.fundingSources.length === 0"
                  >
                    <i>There must be a valid bank account for the retry.</i>
                  </p>
                </div>
              </div>
              <div class="row top-margin">
                <div class="col-md-12">
                  <span>Please append your comment below *</span>
                  <textarea
                    name="comment"
                    id="comment"
                    rows="4"
                    class="form-control"
                    v-model="comment"
                    v-validate="{ required: true }"
                  ></textarea>
                  <span v-if="errors.has('comment')" class="error-feedback"
                    >You must enter or append a comment.</span
                  >
                </div>
              </div>
              <div class="row top-margin">
                <div class="col-md-10">
                  <button
                    type="submit"
                    class="btn btn-info btn-lg button-white buttons"
                    @click="cancel"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    class="btn btn-info btn-lg button-approve buttons"
                    @click="submitRequest"
                    :disabled="isSubmitDisabled"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import {
  SET_ERRORS_MODAL_INFO,
  SHOW_ERRORS_MODAL,
} from '@/store/mutation-types';
import Actions from '@/data/static/upcomingTransactionActions';
import spinner from '@/components/widgets/Spinner';

export default {
  name: 'RetryPayment',
  data() {
    return {
      fundingSources: [],
      selectedFundingSource: '',
      comment: '',
      isLoading: true,
    };
  },
  components: {
    spinner,
  },
  computed: {
    ...mapState('app', [
      'fundingSourceTypes',
    ]),
    donateFundingSource() {
      return Actions.donate;
    },
    transactionAmount() {
      return this.$route.params.transaction.amount;
    },
    transactionId() {
      return this.$route.params.transaction.transactionId;
    },
    accountId() {
      return this.$route.params.account.id;
    },
    id() {
      return this.$route.params.transaction.id;
    },
    isSubmitDisabled() {
      return (
        this.errors.has('comment') ||
        this.errors.has('fundingSource') ||
        this.comment === ''
      );
    },
  },
  async beforeMount() {
    const fundingSources = await this.getAccountFundingSources(
      this.$route.params.account.id,
    );

    this.fundingSources = fundingSources.filter(fss => fss.status === 'verified' &&
      (fss.type === this.fundingSourceTypes.BANK.name ||
        fss.type === this.fundingSourceTypes.CHECK.name ||
        fss.type === this.fundingSourceTypes.WIRE_TRANSFER.name));
    this.isLoading = false;
  },
  methods: {
    ...mapActions('transaction', ['retryFailedTransaction']),
    ...mapActions('account', [
      'getAccountFundingSources',
    ]),
    ...mapMutations('errors', {
      showErrorsModal: SHOW_ERRORS_MODAL,
      setErrorsModalInfo: SET_ERRORS_MODAL_INFO,
    }),
    submitRequest() {
      this.isLoading = true;
      this.retryFailedTransaction({
        accountId: this.accountId,
        fundingSourceId: this.selectedFundingSource,
        transactionId: this.id,
        comment: this.comment,
      })
        .then(() => {
          this.$router.push({ name: 'FailedTransactionList' });
        })
        .catch(() => {
          this.setErrorsModalInfo(['Something went wrong. Please try again.']);
          this.showErrorsModal();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    cancel() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.line-separator {
  padding: 8px;
  line-height: 1.52857143;
  vertical-align: top;
  border-top: 1px solid #eee;
}

.left-margin {
  margin-left: 2%;
}

.right-margin {
  margin-left: -4%;
}

.top-margin {
  margin-top: 2%;
}

.bottom-margin {
  margin-bottom: 1%;
}

.space {
  margin-top: 4%;
}

.content-heading {
  font-weight: normal;
}

.panel-title {
  font-size: 20px;
}

.panel-subtitle {
  font-size: 16px;
}

.panel-default {
  padding: 30px 40px;
  width: 100%;
}

.panel-heading {
  background-color: #ffffff;
  font-size: 16px;
  padding: 0px 5px;
}

label {
  color: #888;
  font-size: 14px;
  width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.total-amount {
  font-size: 20px;
}

.button-approve {
  background-color: #127285;
}

.button-white {
  background-color: white;
  border-color: #127285;
  color: #127285;
}

.btn-back {
  color: #31b0d5;
  background-color: Transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
  padding-left: 20px;
}

.icon-back {
  position: relative;
}

.icon-back:before {
  content: '\f060';
  font-family: FontAwesome;
  position: absolute;
  left: 0px;
}

.buttons {
  display: inline-block;
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// RetryPayment.vue?24e30cab